module.exports = __webpack_public_path__ + "img/Feature.28fc2ef9.png";